import React from "react";

// reactstrap components
import {Badge, CardBody, CardHeader, Col, Row} from "reactstrap";
import withNotify from "../../../../lib/NotificationWrapper";
import CardShowContent from "./CardShowContent";

class JobCrafting extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.score = 14;
        this.topScore = 16;
    }

    get total() {
        if (!this.props.data || !this.props.data.total_cut_point_applied) {
            return 0;
        }
        return this.props.data.total_cut_point_applied || 0;
    }

    renderHigh() {
        return (
            <>
                {window.gettext("Você utiliza um amplo conjunto de estratégias proativas para transformar seu trabalho na direção de torná-lo mais motivador e interessante. Você regula seu engajamento pensando no significado do seu trabalho, pedindo e solicitando feedbacks constantes para seus colegas e supervisores, e, por fim, modificando e adicionando tarefas ao seu trabalho.")}
            </>
        );
    }

    renderLower() {
        return (
            <>
                {window.gettext("Você busca em crenças pessoais a forma de lidar com demandas de trabalho e manter seu nível de engajamento e motivação em relação ao seu trabalho. Você pode desenvolver outras estratégias, mais voltadas para os relacionamentos interpessoais e a gestão de tarefas para torná-lo mais satisfatório e motivador.")}
            </>
        )
    }

    isHigher() {
        if (this.total) {
            return this.total >= this.score;
        }
        return false;
    }

    getDescription() {
        if (this.isHigher()) {
            return this.renderHigh();
        }
        return this.renderLower();
    }

    render() {

        return (
            <>
                <div className="content ancora-container">
                    <Row>
                        <Col md={12}>
                            <CardShowContent
                                isHigher={this.isHigher()}
                                topScore={this.topScore}
                                description={this.getDescription()}
                                total={this.total}
                                helper={window.gettext('São comportamentos proativos no trabalho que consistem em iniciativas individuais informais que buscam modificar o trabalho para otimizar seus recursos e demandas, ou para torná-lo mais envolvente e gratificante.')}
                                title={window.gettext('Job Crafting')}
                            />
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default withNotify(JobCrafting);
